<div class="modal-confirm" data-cy="modal-confirm-general">
    <div class="modal-header">
        <p class="modal-title" data-cy="modal-confirm-general-title">Confirm</p>
        <button data-cy="modal-confirm-close-button" type="button" class="close" (click)="activeModal.dismiss()"></button>
    </div>

    <div class="modal-body">
        <div class="modal-confirm-subtitle" data-cy="modal-manual-general-subtitle">You haven't finished your {{title}}! Are you sure you want to leave and remove all the unsaved information?</div>
    </div>

    <div data-cy="modal-general-buttons" class="modal-footer">
        <button type="button"
                class="btn-secondary"
                (click)="clickPrimaryButton()"
                data-cy="modal-general-secondary-button">Leave this page</button>
        <button type="button"
                class="btn-primary"
                (click)="activeModal.dismiss()"
                data-cy="modal-general-primary-button">Stay on this page</button>
    </div>
</div>
